/**
 * @module header/components/navigation
 */
import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import classnames from 'classnames';

const Navigation = ({ shouldShow, links, location = { pathname: '' }, isLoggedIn = false }) => {
  if (!shouldShow) {
    return null;
  }

  const { pathname } = location;
  const wrapperClasses = classnames('columns', {
    'medium-10 large-11 hide-for-small-only': isLoggedIn,
    'medium-16 large-13': !isLoggedIn,
  });
  return (
    <div className={wrapperClasses}>
      <div className="top-navigation">
        <ul>
          { links.map((link) => {
            const active = pathname.startsWith(link.url);
            const classes = classnames('nav-item', {
              active: active,
              right: link.right,
              hide: link.navOnly || (link.mobileNav === 'right' && isLoggedIn),
            });
            return (<li key={v4()} className={classes}>
              {!active && <Link rel={link.rel} to={link.url}>{link.name}</Link>}
              {active && <span className="active">{link.name}</span>}
            </li>);
          })}
        </ul>
      </div>
      {!isLoggedIn &&
        <div className="login-nav text-right show-for-small-only">
          <Link to="/login" rel="nofollow">Login</Link>
        </div>
      }
    </div>
  );
};

Navigation.propTypes = {
  shouldShow: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string,
  })),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  isLoggedIn: PropTypes.bool,
};

export default Navigation;



// WEBPACK FOOTER //
// ./header/components/navigation.jsx